import pro1 from "../assests/Anirudh-cad.jpg";



const ProjectCardData = [

  {
    imgsrc: pro1,
    title: "Auto CAD 2D Drawing",
    text: " Created a detailed 2D model of Charminar using AutoCAD with commands like Line, Circle, Arc, Offset, Trim, Extend, Copy, and Mirror. Showcases precision drafting and command proficiency. ",
    view: "https://drive.google.com/file/d/1OI7OLSBB9ECZd79wKlytJKM-JXkPX5vR/view?usp=sharing",
  },

 
  
  
  
];
export default ProjectCardData;
